export const checkIFQAEnv = () => {
    return window.location.hostname === "qa.culturebie.com" ||
        window.location.hostname === "www.qa.culturebie.com"
}

export const checkPath = (path)=>{
    let paths = window.location.pathname&&window.location.pathname.split("/")
    return paths&&paths[paths.length-1]&&paths[paths.length-1]=== path?true:false
}
